import { P0, S, abs, arc, fillAt, frac, max, min, quad } from '../../geometry';

export const volcano = {
  name: 'Volcano',
  colors: ['#C46A3E', '#E5484D'],
  draw(m, t) {
    let on = 0.9,
      rate = 0.35,
      H = 7,
      crater = 0,
      pose = P0();
    if (m === 'happy') {
      rate = 1.2;
      H = 26;
      on = 1;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: lava keeps popping out of the crater in arcs while the mountain rumbles.
    if (m === 'thinking') {
      rate = 0.85;
      H = 22;
      on = 1;
      pose.tx = 0.6 * S(t * 23);
    }
    if (m === 'talking') {
      crater = -2.5 * max(0, S(t * 10));
      rate = 0.9;
      H = 11;
    }
    if (m === 'surprised') {
      rate = 1.5;
      H = 34;
      on = 1;
      crater = -3;
      pose.ty = -2;
    }
    if (m === 'paused') {
      rate = 0.2;
      H = 3;
      on = 0.6;
      pose.ty = 2;
      pose.sy = 0.96;
    }
    const mtn = [
      [14, 86],
      ...quad([14, 86], [30, 66], [37, 38 + crater], 6).slice(1),
      [43, 36 + crater],
      [50, 39 + crater],
      [57, 36 + crater],
      ...quad([63, 38 + crater], [70, 66], [86, 86], 6),
      [14, 86],
    ];
    const blobs = [
      [-15, 0.8],
      [4, 1.15],
      [17, 0.95],
    ].map(([dx, hk], i) => {
      const f = frac(t * rate + i / 3),
        x = 50 + dx * f * (H / 22 + 0.3),
        y = 34 + crater - H * hk * 4 * f * (1 - f) + 4 * f * f;
      return {
        c: 'b',
        pts: arc(x, y, 1.3, -90, 270, 9),
        o: on * min(1, f * 8) * min(1, (1 - f) * 5),
        snap: true,
      };
    });
    return {
      strokes: [
        { c: 'a', pts: mtn, n: 40, sharp: true },
        {
          c: 'b',
          pts: [
            [44, 37 + crater],
            [56, 37 + crater],
          ],
        },
        ...blobs,
      ],
      eyes: { x: 50, y: 63 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
